import React from 'react';
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';

import { CustomHeading } from 'shared-components';

interface IDataGridHeaderProps {
  title: string;
  activeComponent?: React.ReactNode;
  toolbarComponent?: React.ReactNode;
}

export const DataGridHeader = (props: IDataGridHeaderProps): React.ReactNode => {
  const { title, toolbarComponent, activeComponent } = props;

  const isMobile = useBreakpointValue({ base: true, md: false });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <Box pl={{ base: 4, md: 8 }} pr={4} pt={4} pb={0}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <CustomHeading level="h1" mb={0}>
          {title}
        </CustomHeading>

        {activeComponent ? (
          <>
            {isMobile ? (
              <>
                <Button ref={btnRef} onClick={onOpen}>
                  Choose data
                </Button>

                <Drawer isOpen={isOpen} placement={'right'} onClose={onClose} finalFocusRef={btnRef}>
                  <DrawerOverlay />
                  <DrawerContent maxWidth={'18rem'}>
                    <DrawerCloseButton />
                    <DrawerHeader>Choose data</DrawerHeader>

                    <DrawerBody>{activeComponent}</DrawerBody>
                  </DrawerContent>
                </Drawer>
              </>
            ) : (
              <Box display="flex" justifyContent="left" alignItems="center">
                {activeComponent}
              </Box>
            )}
          </>
        ) : null}
      </Box>

      {toolbarComponent}
    </Box>
  );
};
